import { useAppSelector } from 'app/store';
import { ROLE_SUPER_ADMIN } from './../../constants';

export function IsSuperAdmin({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups && groups.includes(ROLE_SUPER_ADMIN)) return children;
}

export function IsSuperAdminGuard(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups && groups.includes(ROLE_SUPER_ADMIN);
}
